export default __webpack_public_path__ + "static/char-v-56-ja-399be33541eed74e1d9997618c370328.mp4";